module.exports = "<div>\n    <h3>{{$ctrl.selectedNews.categoria}}</h3>\n    <h1 ng-bind-html=\"$ctrl.selectedNews.title\"></h1>\n    <h4>\n        {{$ctrl.selectedNews.data}}\n        <small class=\"pull-right\">\n            <a class=\"btn btn-default btn-primary\"\n               ng-hide=\"$ctrl.selectedNews.url.indexOf('elencoNewsSede.do') > -1\"\n               ng-href=\"{{$ctrl.selectedNews.url}}\" fm-external-link>Apri</a>\n        </small>\n    </h4>\n    <p ng-if=\"$ctrl.selectedNews.content\" ng-bind-html=\"$ctrl.selectedNews.content\"></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/news/mainNewsItem/mainNewsItem.html
// module id = 417
// module chunks = 0